<template>
  <div v-loading="opdLoading">
    <div style="margin-bottom: 1.5rem">
      <content-title title="当日进销存"></content-title>
      <mii-base-table style="margin-bottom: 0.3rem" :datas="jxcDatas" :table_style="1" :ths="jxcThs"></mii-base-table>
    </div>
    <div style="margin-bottom: 1.5rem" v-for="(item, key) in opdOilDetail.orderList">
      <content-title :title="key + ': ' + item['total']"></content-title>
      <mii-base-table style="margin-bottom: 0.3rem" :datas="item['psList']" :table_style="1" :ths="psThs"></mii-base-table>
      <mii-base-table style="margin-bottom: 1.5rem" :datas="item['orders']" v-if="item['orders'] && item['orders'].length > 0" :table_style="2" :ths="orThs" :lineQF="true"></mii-base-table>
    </div>
  </div>
</template>

<script>
import ContentTitle from '@/components_bit/ContentTitle'
import MiiBaseTable from '@/components_bit/MiiBaseTable'

export default {
  data () {
    return {
      jxcThs: [{
        label: '加油站',
        key: '加油站名称'
      },
      {
        label: '罐号',
        key: '罐号'
      },
      {
        label: '油品类型',
        key: '油品名称'
      },
      {
        label: '入库(L)',
        key: '入库升数'
      },
      {
        label: '出库(L)',
        key: '出库升数'
      },
      {
        label: '期末库存(L)',
        key: '期末库存'
      },
      {
        label: '空容(L)',
        key: '空容'
      },
      {
        label: '平均销量(L)',
        key: '平均销量'
      },
      {
        label: '在途(L)',
        key: '在途计划升数'
      },
      {
        label: '配送计划(L)',
        key: '配送计划'
      },
      {
        label: '物理容积(L)',
        key: '物理容积'
      },
      {
        label: '停泵库存(L)',
        key: '停泵库存'
      },
      {
        label: '有效容积(L)',
        key: '有效容积'
      }],
      loading: false,
      psThs: [{
        key: 'SFID',
        label: 'ID'
      },
      {
        key: '车牌号',
        label: '车牌号'
      },
      {
        key: '罐号',
        label: '罐号'
      },
      {
        key: '物理容积',
        label: '物理容积'
      },
      {
        key: '空容',
        label: '空容'
      },
      {
        key: '平均销量',
        label: '平均销量'
      },
      {
        key: '配送升数',
        label: '配送升数'
      },
      {
        key: '不容纳时间',
        label: '不容纳时间'
      },
      {
        key: '断货时间',
        label: '断货时间'
      },
      {
        key: '预计发车时间',
        label: '预计发车时间'
      },
      {
        key: '趟次',
        label: '趟次'
      },
      {
        key: '隔仓号',
        label: '隔仓号'
      }],
      orThs: [{
        key: 'SFID',
        label: 'ID'
      },
      {
        key: '罐号',
        label: '罐号'
      },
      {
        key: '物理容积',
        label: '物理容积'
      },
      {
        key: '空容',
        label: '空容'
      },
      {
        key: '平均销量',
        label: '平均销量'
      },
      {
        key: '建议配送量',
        label: '配送升数'
      },
      {
        key: '不容纳时间',
        label: '不容纳时间'
      },
      {
        key: '断货时间',
        label: '断货时间'
      }]
    }
  },
  components: {
    ContentTitle,
    MiiBaseTable
  },
  computed: {
    jxcDatas: {
      get () {
        return this.$store.getters.oilHisJxcDatas
      }
    },
    opdOilDetail: {
      get () {
        return this.$store.getters.opdOilDetail
      }
    },
    opdLoading: {
      get () {
        return this.$store.getters.opdLoading
      }
    }
  }
}
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// oil_ps_detail.vue?1614a2f4